import { Component, OnInit, OnDestroy } from '@angular/core';
import { DownloadService } from '@fuse/services/download/download.service';
import { TranslateService } from '@ngx-translate/core';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { fuseAnimations } from '@fuse/animations';
import { FormControl } from '@angular/forms';


@Component({
    selector: 'download-management',
    templateUrl: './download-management.component.html',
    styleUrls: ['./download-management.component.scss'],
    animations: fuseAnimations
})
export class DownloadManagementComponent implements OnInit, OnDestroy {

    private _unsubscribeAll: Subject<any>;

    searchInput: FormControl;
    lang = 'sr';

    constructor(
        private _downloadService: DownloadService,
        private _translate: TranslateService,
        private _translationLoader: FuseTranslationLoaderService,
    ) {
        this._unsubscribeAll = new Subject();
        this.searchInput = new FormControl('');
    }

    ngOnInit(): void {
        this.getTranslations();
        this._translationLoader.onLangChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(value => {
                this.getTranslations();
            });
    }

    getTranslations(): void {
        this._translationLoader.getLastLang()
        .then(response => {
            this.lang = response['code'];
            this._translationLoader.getTranslations(this.lang, '3');
            console.log(this.lang);
        })
        .catch(err => Promise.reject(err))
        .then(() => {
        }, err => {
        });
    }

    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }
}
